import styled from 'styled-components';
import confidentialLabelStyle from '../utils/confidentialLabelStyle';
import __ from '../utils/translator';

export default styled.div`
  position: absolute;
  top: 0;
  right: 0;
  ${confidentialLabelStyle};
  
  &:after {
    content: "${__('Draft')}";
  }
`;
